import { type JanusCtx, handBack } from '../context.js';

export type DieTuple = [number, string, Record<string, unknown>?];

/** includes/functions/janus/dice/roll_dice_arr.php, after its two summary tuples are removed. */
export function rollDiceFaces(ctx: JanusCtx, dice: number, die: number, advDisStacks = 0): { total: number; faces: DieTuple[] } {
  if (![dice, die, advDisStacks].every(Number.isSafeInteger) || dice < 0 || dice > 100 || die < 0 || die > 1000
      || Math.abs(advDisStacks) > 100 || (dice > 0 && die < 1)) handBack('roll_dice_arr:invalid-arguments');
  const faces: DieTuple[] = [];
  let total = 0;
  if (!dice || !die) return { total, faces };
  for (let x = 1; x <= dice; x++) {
    if (!advDisStacks) {
      const value = ctx.roll.d(die);
      total += value;
      faces.push([value, `d${die}_${x}`, { kept: true }]);
      continue;
    }
    const pair: DieTuple[] = [];
    for (let r = 1; r <= Math.abs(advDisStacks) + 1; r++)
      pair.push([ctx.roll.d(die), `d${die} ${advDisStacks > 0 ? 'ADV' : 'DIS'}${Math.abs(advDisStacks)}`, { roll_order: r }]);
    pair.sort((a, b) => advDisStacks > 0 ? b[0] - a[0] : a[0] - b[0]);
    pair.forEach((tuple, index) => { tuple[2]!.kept = index === 0; });
    total += pair[0]![0];
    faces.push(...pair);
  }
  // PHP rsort compares the whole tuple, so equal faces sort by their dN_index label.
  if (!advDisStacks) faces.sort((a, b) => b[0] - a[0] || b[1].localeCompare(a[1], 'en', { numeric: false }));
  return { total, faces };
}
